import { Image as BoltImage } from '@sainsburys-tech/bolt';
import styled from 'styled-components';
var FooterContainer = styled.div.withConfig({
  displayName: "DrawerFooterstyles__FooterContainer",
  componentId: "s1la6y-0"
})(["display:flex;align-items:", ";width:100%;margin-bottom:15px;"], function (props) {
  return props.stretch ? 'stretch' : 'center';
});
var FooterImageWrapper = styled.div.withConfig({
  displayName: "DrawerFooterstyles__FooterImageWrapper",
  componentId: "s1la6y-1"
})(["flex-basis:48px;"]);
var FooterImage = styled(BoltImage).withConfig({
  displayName: "DrawerFooterstyles__FooterImage",
  componentId: "s1la6y-2"
})(["width:48px;height:48px;"]);
var FooterTextWrapper = styled.span.withConfig({
  displayName: "DrawerFooterstyles__FooterTextWrapper",
  componentId: "s1la6y-3"
})(["flex:1;flex-direction:column;display:flex;text-align:left;padding-left:10px;line-height:", ";"], function (props) {
  return props.theme.font['line-height']['label-1'];
});
var FooterHeading = styled.span.withConfig({
  displayName: "DrawerFooterstyles__FooterHeading",
  componentId: "s1la6y-4"
})(["font-weight:", ";"], function (props) {
  return props.theme.font.weight.bold;
});
var FooterSubHeading = styled.span.withConfig({
  displayName: "DrawerFooterstyles__FooterSubHeading",
  componentId: "s1la6y-5"
})(["font-weight:", ";text-align:right;"], function (props) {
  return props.theme.font.weight.bold;
});
export { FooterContainer, FooterImageWrapper, FooterImage, FooterHeading, FooterTextWrapper, FooterSubHeading };